import dailyCover from "@/http/requests/dailyCover"

export default {
  fetch({ commit }, queryData) {
    return new Promise((resolve, reject) => {
      dailyCover.fetch(queryData).then(response => {
        commit('SET_DAILY_COVERS', response.data.data.dailyCovers)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      dailyCover.add(data).then(response => {
        commit('ADD_DAILY_COVER', response.data.data.createDailyCover)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, dailyCoverId) {
    return new Promise((resolve, reject) => {
      dailyCover.delete(dailyCoverId).then(response => {
        commit('DELETE_DAILY_COVER', dailyCoverId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos({ commit }, dailyCoverId) {
    return new Promise((resolve, reject) => {
      dailyCover.infos(dailyCoverId).then(response => {
        commit('SET_DAILY_COVER_INFOS', response.data.data.dailyCoverInfos)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  }
}
